/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react'
import {
  Box,
  Grid,
  IconButton,
  Input,
  InputAdornment,
  Typography,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import TabNav from '../../../../../components/ui/TabNav'
import { CustomSwitch } from '../../../../../components/ui/custom-switch'
import { mdiAccountSearch, mdiMagnify } from '@mdi/js'
import Icon from '@mdi/react'
import BaseFilter from '../../../../../components/hooks/BaseFilter'
import SelectField from '../../../../components/SelectField'
import { useDispatch } from 'react-redux'
import { fetchLaundryServiceTypes } from '../../PartnersActions'

const useStyles = makeStyles({
  filterBox: {
    display: 'flex',
    gap: '8px',
  },
})

const ServiceTypesFilter = ({ editingId, onlyActive, onToggleActive }) => {
  const [form, setForm] = useState({
    service_type: '',
    os_type: '',
    os_type_id: '',
  })

  const classes = useStyles()
  const dispatch = useDispatch()

  const getLaundryServiceTypes = (filters = form) => {
    dispatch(fetchLaundryServiceTypes(editingId, filters))
  }

  const handleChangeOsType = osType => {
    const filters = {
      ...form,
      os_type: osType ? osType : '',
      os_type_id: osType ? osType?.id : '',
    }

    setForm(filters)
    getLaundryServiceTypes(filters)
  }

  const handleSubmit = e => {
    e.preventDefault()
    getLaundryServiceTypes()
  }

  useEffect(() => {
    if (!editingId) return
    getLaundryServiceTypes()
  }, [editingId])

  return (
    <BaseFilter>
      <Grid item xs={12}>
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item xs={8}>
            <form onSubmit={handleSubmit}>
              <Grid container spacing={4}>
                <Grid item>
                  <Input
                    fullWidth
                    name="name"
                    value={form?.service_type}
                    onChange={e =>
                      setForm({ ...form, service_type: e.target.value })
                    }
                    id="standard-adornment-service-type"
                    style={{ marginTop: '16px' }}
                    placeholder="Pesquise por tipo de serviço"
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="search service-type"
                          type="submit"
                        >
                          <Icon path={mdiMagnify} size={1} />
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </Grid>

                <Grid item xs>
                  <SelectField
                    options={[
                      { id: 1, name: 'Mensal' },
                      { id: 2, name: 'Avulso' },
                    ]}
                    setForm={(name, osType) => handleChangeOsType(osType)}
                    data={form?.os_type || ''}
                    style={{ maxWidth: '230px' }}
                    variant="standard"
                    name="status"
                    label="Filtre por tipo na OS"
                  />
                </Grid>
              </Grid>
            </form>
          </Grid>

          <Grid item>
            <Grid container justifyContent="flex-end">
              <Box className={classes.filterBox}>
                <Box className={classes.filterBox}></Box>
                <Box className={classes.filterBox}>
                  <CustomSwitch
                    checked={onlyActive}
                    onChange={onToggleActive}
                  />
                  <Typography>Apenas Ativos</Typography>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </BaseFilter>
  )
}

export default ServiceTypesFilter
